import { render, staticRenderFns } from "./Game6-10.vue?vue&type=template&id=f0e6ac0e&scoped=true&"
import script from "./Game6-10.vue?vue&type=script&lang=js&"
export * from "./Game6-10.vue?vue&type=script&lang=js&"
import style0 from "./Game6-10.vue?vue&type=style&index=0&id=f0e6ac0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e6ac0e",
  null
  
)

export default component.exports